import { getFirstLikeIndex } from "$/util/creation_util";
import {
  getCreationSingleURLv2,
  getCreationUrl,
  titleize,
  trimEllip,
} from "@blackink/core/creation/util";
import ShoppingCartIcon from "@mui/icons-material/AddShoppingCartSharp";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import {
  Box,
  Card,
  CardActionArea,
  IconButton,
  ImageListItem,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import CreationImage from "./CreationImage";
import FavoriteButton from "./FavoriteButton";

function CreationHorizontalList(props) {
  const { items, showFavorite, showShopping, disableBlur, hideTitle } = props;

  if (!items) {
    return null;
  }

  return (
    <Tabs
      variant="scrollable"
      scrollButtons="auto"
      value={false} // hack to prevent warning
      sx={{
        gridAutoFlow: "column",
        gridTemplateColumns: "repeat(auto-fill,minmax(200px,0fr)) !important",
        gridAutoColumns: "minmax(200px, 0fr)",
        // scroll bar hidden
        overflowX: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        position: "relative",
      }}
      ScrollButtonComponent={(props) => {
        const passProps = { ...props };
        delete passProps.slots;
        delete passProps.slotProps;

        return (
          <IconButton
            sx={{
              position: "absolute",
              left: props.direction === "left" ? 0 : "auto",
              right: props.direction === "right" ? 0 : "auto",
              top: "35%",
              transform: "translateY(-50%)",
              backgroundColor: "white",
              borderRadius: "50%",
              zIndex: 100,
              margin: "10px",
              height: 32,
              width: 32,
              "&:hover": {
                backgroundColor: "white",
                boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
              },
              "&:disabled": {
                display: "none",
              },
            }}
            // All props except slots and slotProps
            {...passProps}
          >
            {props.direction === "left" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        );
      }}
    >
      {items
        .filter((item) => item.status !== "ERROR")
        .map((item, index) => (
          <Tab
            key={index}
            sx={{
              opacity: 1,
              minWidth: "0px",
              padding: 0,
              justifyContent: "flex-start",
              textAlign: "left",
              textTransform: "none",
              "&:hover": {
                cursor: "default",
              },
            }}
            disableRipple
            disableFocusRipple
            disableTouchRipple
            label={
              <ImageListItem sx={{ maxWidth: 200, mr: 1 }}>
                <Card variant="outlined" sx={{ border: "none" }}>
                  <CardActionArea
                    component={Link}
                    to={
                      showShopping
                        ? getCreationSingleURLv2(item, getFirstLikeIndex(item))
                        : getCreationUrl(item)
                    }
                    sx={{
                      borderRadius: 2,
                    }}
                  >
                    <CreationImage
                      creation={item}
                      lazy={index >= 8}
                      indexToShow={getFirstLikeIndex(item)}
                      fixedImageHeight={200}
                      disableBlur={disableBlur}
                    />
                  </CardActionArea>

                  <Stack direction="row" alignItems="flex-start" mt={0.5}>
                    {!hideTitle && (
                      <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle1">
                          {titleize(trimEllip(item.prompt, 40))}
                        </Typography>
                      </Box>
                    )}
                    {showFavorite && (
                      <FavoriteButton
                        creationId={item.id}
                        idx={getFirstLikeIndex(item)}
                        hideCount
                      />
                    )}
                    {showShopping && (
                      <IconButton
                        component={Link}
                        to={getCreationSingleURLv2(item, getFirstLikeIndex(item))}
                        sx={{ borderRadius: "25%" }}
                      >
                        <ShoppingCartIcon />
                      </IconButton>
                    )}
                  </Stack>
                </Card>
              </ImageListItem>
            }
          />
        ))}
    </Tabs>
  );
}

export default CreationHorizontalList;
